import React, { useState } from "react";
import { DotChartOutlined } from "@ant-design/icons";
import { Flex, Divider, Form, Radio, Skeleton, Space, Switch } from "antd";
import styles from "../loadingSkeleton.module.css";
const LoadingSkeletonTourDetails = () => {
  const [active, setActive] = useState(true);
  const [block, setBlock] = useState(true);
  const [size, setSize] = useState("default");
  return (
    <div
      className={styles.nomargin}
      style={{
        maxWidth: "100vw",
        overflowX: "hidden",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
      }}
    >
      <div
        className={styles.nomargin}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          paddingLeft: "2rem",
          paddingRight: "2rem",
          // overflow: "hidden",
        }}
      >
        <div
          className={styles.nomargin}
          style={{
            paddingTop: "3rem",
            paddingBottom: "1rem",
            width: "100%",
            maxWidth: "30rem",
          }}
        >
          <Skeleton.Input
            className={styles.nomargin}
            style={{
              width: "100%",
            }}
            active={active}
            size={size}
            block={block}
          />
        </div>
        <div
          className={styles.nomargin}
          style={{
            paddingTop: "0rem",
            paddingBottom: "1rem",
            width: "100%",
            maxWidth: "30rem",
          }}
        >
          <Skeleton.Input
            className={styles.nomargin}
            style={{
              width: "100%",
            }}
            active={active}
            size={size}
            block={block}
          />
        </div>
        <div
          className={styles.nomargin}
          style={{
            width: "100%",
            height: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            flexWrap: "wrap",
            paddingTop: "2rem",
            paddingBottom: "1rem",
          }}
        >
          <Skeleton.Image
            className={styles.nomargin}
            style={{
              width: "90vw",
              height: "90vw",
              maxWidth: "90rem",
              maxHeight: "40rem",
            }}
            active={active}
          />
        </div>
        <div
          className={styles.nomargin}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          <div
            className={styles.nomargin}
            style={{
              width: "100%",
              maxWidth: "26rem",
              overflow: "hidden",
              paddingBottom: "1rem",
              paddingTop: "1rem",
              paddingRight: "1rem",
            }}
          >
            <Skeleton.Input
              className={styles.nomargin}
              style={{
                width: "100vw",
                height: "12rem",
                maxWidth: "26rem",
                overflow: "hidden",
              }}
              active={active}
            />
          </div>

          <div
            className={styles.nomargin}
            style={{
              width: "100%",
              maxWidth: "26rem",
              overflow: "hidden",
              paddingTop: "1rem",
              paddingBottom: "1rem",

              paddingLeft: "1rem",
            }}
          >
            <Skeleton.Input
              className={styles.nomargin}
              style={{
                width: "100vw",
                height: "12rem",
                maxWidth: "26rem",
                overflow: "hidden",
              }}
              active={active}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoadingSkeletonTourDetails;
